import React from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Oval } from "react-loader-spinner";
import LabelForm from "pages/signup/form/labelForm";
import BGShutterstock from "images/auth/bg-shutterstock.png";
import { ReactComponent as TVendorIcon } from "images/auth/t-vendors.svg";
import { ReactComponent as ApprovedImage } from "images/externalPage/high-five.svg";
import { ReactComponent as DeclineImage } from "images/externalPage/decline-image.svg";
import useConfirmFinanceGroupedInvoice from "./useConfirmFinanceGroupedInvoice";
import Input from "components/input";

const ConfirmFinanceGroupedInvoice = () => {
  const [t] = useTranslation();

  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm();

  const {
    onSubmit,
    navigate,
    isLoading,
    approvedParam,
    successMsg,
    setRejectionReason,
    isGroupedInvoice,
    data,
    loading,
    error,
  } = useConfirmFinanceGroupedInvoice();
  if (loading)
    return (
      <div className="mt-[220px] px-[10%] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] flex flex-col mb-[97px] relative min-h-[calc(100vh-750px)] items-center justify-center">
        <div className="flex items-center justify-center h-screen bg-white dark:bg-gray-900">
          <Oval
            height="80"
            width="80"
            color="#023A66"
            ariaL
            abel="loading-indicator"
            secondaryColor="#023A66"
          />
        </div>
      </div>
    );
  if (error)
    return (
      <div className="mt-[220px] px-[10%] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] flex flex-col mb-[97px] relative min-h-[calc(100vh-750px)] items-center justify-center">
        <DeclineImage />
        <LabelForm
          label={t(error)}
          labelClassName="text-primary font-bold text-[22px] md-max:text-[18px] not-italic ml-[15px]"
        />
      </div>
    );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div
        className="w-full h-[100px] bg-no-repeat  bg-cover bg-center flex items-center px-[20%] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] fixed z-[999999999]"
        style={{
          backgroundImage: `url(${BGShutterstock})`,
          zIndex: 100,
        }}
      >
        <div className="max-w-[843px] w-full flex items-center justify-between">
          <TVendorIcon
            onClick={() => navigate("/login")}
            className="cursor-pointer"
          />
        </div>
      </div>

      {!successMsg ? (
        <div className="mt-[220px] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] flex flex-col mb-[97px] relative min-h-[calc(100vh-750px)] items-center justify-center">
          <div className="text-primary text-[16px] md:text-[14px] leading-relaxed space-y-4">
            <p className="font-bold text-[20px] md:text-[16px] text-center">
              {approvedParam === "true"
                ? isGroupedInvoice
                  ? t("rejectionReasonAcceptMsg2")
                  : t("rejectionReasonAcceptMsg")
                : isGroupedInvoice
                ? t("rejectionReasonTitle2")
                : t("rejectionReasonTitle")}
            </p>

            <div className="space-y-3 text-[16px] md:text-[14px] leading-relaxed text-primary">
              <p>
                <span className="font-semibold">
                  {isGroupedInvoice
                    ? t("rejectionReasonDeclineMsgPart4_1")
                    : t("rejectionReasonDeclineMsgPart4")}
                </span>{" "}
                <span className="text-dark-gray">{data?.invoiceNumber}</span>
              </p>

              <p>
                <span className="font-semibold">
                  {t("rejectionReasonDeclineMsgPart5")}
                </span>{" "}
                <span className="text-dark-gray">{data?.requestedBy}</span>
              </p>

              <p>
                <span className="font-semibold">
                  {t("rejectionReasonDeclineMsgPart6")}
                </span>{" "}
                <span className="text-dark-gray">{data?.reasonProvidedBy}</span>
              </p>
              <p>
                <span className="font-semibold">
                  {t("rejectionReasonDeclineMsgPart7")}
                </span>{" "}
                <span className="text-dark-gray">{data?.accountName}</span>
              </p>
              <p>
                <span className="font-semibold">
                  {t("rejectionReasonDeclineMsgPart8")}
                </span>{" "}
                <span className="text-dark-gray">
                  {`${data?.totalAmountWithVat} ${data?.currency}`}
                </span>
              </p>

              <p className="font-semibold mb-2">
                {t("rejectionReasonDeclineMsgPart3")}
              </p>
              <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 text-dark-gray  mx-auto auto-rows-auto">
                {data?.orderData?.map((item, idx) => (
                  <a
                    key={idx}
                    href={item.orderLink}
                    className="bg-gray-50 border p-2 rounded whitespace-nowrap justify-self-start block"
                  >
                    {item.orderNumber}
                  </a>
                ))}
              </div>
            </div>

            {approvedParam === "false" && (
              <>
                <LabelForm
                  label={
                    approvedParam === "true"
                      ? t("rejectionReasonAcceptMsg")
                      : t("rejectionReason")
                  }
                  labelClassName="text-primary font-bold text-[20px] md-max:text-[16px] not-italic"
                />
                <p>{t("rejectionReasonDeclineMsgPart2")}</p>
                <div className="flex items-end justify-end gap-[10px] mt-[20px] w-full">
                  <Input
                    isRequired={true}
                    placeholder={t("rejectionReason")}
                    name="rejectionReason"
                    register={register}
                    registerArgs={{
                      required: t("errorField", {
                        field: t("rejectionReason"),
                      }),
                    }}
                    errorMessage={
                      errors.rejectionReason && !watch("rejectionReason")
                        ? errors.rejectionReason.message
                        : ""
                    }
                    onChange={(e) => {
                      setRejectionReason(e.target.value);
                    }}
                    containerClassName={"w-full"}
                    inputClassName={`flex h-[43px] w-full sm-max:w-full items-center gap-[8px] self-stretch rounded-[6px] border-[1px] border-solid ${
                      errors.rejectionReason && !watch("rejectionReason")
                        ? "border-red"
                        : "border-default-color"
                    } bg-transparent outline-none text-dark-gray font-regular text-[16px] not-italic  placeholder:font-regular placeholder:text-[16px] placeholder:not-italic placeholder:font-normal py-[16px] px-[14px]`}
                  />
                </div>
              </>
            )}
          </div>

          <div className="flex items-end justify-end gap-[10px] mt-[20px]">
            <button
              type="submit"
              disabled={isLoading}
              className="cursor-pointer flex py-[14px] px-[16px] gap-[8px] justify-center items-center rounded-[6px] border-[1px] border-solid border-primary bg-primary h-[46px] w-[150px]"
            >
              <Oval
                height={30}
                width={30}
                color="#FFF"
                visible={isLoading}
                ariaLabel="oval-loading"
                secondaryColor="#FFF"
                strokeWidth={5}
                strokeWidthSecondary={3}
              />
              <div className="text-white font-bold text-[16px] not-italic">
                {approvedParam === "false" ? t("reject") : t("Yes")}
              </div>
            </button>
          </div>
        </div>
      ) : (
        <div className="mt-[220px] px-[10%] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] flex flex-col mb-[97px] relative min-h-[calc(100vh-750px)] items-center justify-center">
          {approvedParam === "true" ? <ApprovedImage /> : <DeclineImage />}
          <LabelForm
            label={t(successMsg)}
            labelClassName="text-primary font-bold text-[22px] md-max:text-[18px] not-italic ml-[15px]"
          />
        </div>
      )}
    </form>
  );
};

export default ConfirmFinanceGroupedInvoice;
